import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from "@ngx-translate/core";
import { EditorEncuestaService } from "../editor-encuesta.service";
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_editorBroker } from 'app/idiomas/i18n/editor-broker/editor-broker.lang';
import { ModalImagenHtmlComponent } from "../modal-imagen-html/modal-imagen-html.component";

@Component({
  selector: 'app-modal-editor',
  templateUrl: './modal-editor.component.html',
  styleUrls: ['./modal-editor.component.scss']
})
export class ModalEditorComponent implements OnInit {

  editorCargado = false;

  opciones: any = {
    menubar: false,
    plugins: 'autoresize print preview paste importcss searchreplace autolink save directionality code visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount image textpattern noneditable help charmap quickbars emoticons',
    toolbar: 'undo redo | bold italic underline strikethrough | fontsizeselect | table | \
              alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | \
              forecolor backcolor removeformat | charmap emoticons | fullscreen  preview | \
              link codesample image | ltr rtl',
    toolbar_sticky: true,
    // height: 250,
    toolbar_mode: 'sliding',
    // language: 'en_US'
  };

  textoOriginal: string;
  botGuardar = false;

  cargandoConfig = true;
  controlesAdicionales = [
    { nombre: 'PIN', activo: false, id: 'isPin' },
    { nombre: 'LIDERES', activo: false, id: 'leadersInSurvey' },
    { nombre: 'RANDOM', activo: false, id: 'enableRandomQuestions' },
  ];
  datosBanderas: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalEditorComponent>,
    private dialog: MatDialog,
    private ees: EditorEncuestaService,
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    lang_editorBroker.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdioma(); });
    if(this.datos.opcion == 'editar'){
      this.cambiaIdioma();
      this.inicializaEditor();
    } else if('configAdicional'){
      this.incializarConfigAdicional();
    }
  }

  cambiaIdioma(){
    switch (this.translateSrv.currentLang) {
      case 'zh1': case 'zh2':
        this.opciones.language = 'zh_CN';
      break;
      case 'pt':
        this.opciones.language = 'pt_PT';
      break;
      default:
        this.opciones.language = this.translateSrv.currentLang;
    }
  }

  inicializaEditor(){
    this.textoOriginal = this.datos.texto;
    setTimeout(() => {
      this.editorCargado = true;
      let esperaImg = setInterval(function () {
        if($(".tox-notifications-container").length && $(".tox-statusbar__branding")){
          $(".tox-notifications-container").hide();
          $(".tox-statusbar__branding").hide();
          clearInterval(esperaImg);
        }
      }, 0);
    }, 2000);
  }

  incializarConfigAdicional(){
    this.ees.getFlagsConfig().subscribe((respuesta:any) => {
      console.log("getFlags:",respuesta);
      if(respuesta.success){
        this.controlesAdicionales.forEach(control => {
          control.activo = respuesta[control.id];
        });
        this.datosBanderas = respuesta;
        delete this.datosBanderas.success;
        this.cargandoConfig = false;
      }
    });
  }

  cambioConfiguracion(indice:number){
    let referenciaControl = this.controlesAdicionales[indice];
    this.datosBanderas[referenciaControl.id] = referenciaControl.activo;
    console.log("nuevosDatos:",this.datosBanderas);
    this.ees.setFlagsConfig(this.datosBanderas).subscribe((respuesta:any) => {
      console.log("setFlagsConfig:",respuesta);
      if(respuesta.success){
        this._snackBar.open(this.translateSrv.instant('EDITOR.CONFIGADICIONAL.SAVEOK'), "OK", {
          duration: 2000,
          horizontalPosition: "center",
          verticalPosition: "bottom",
          panelClass: ['background-red']
        });
      }
    });
  }

  revisaCambios(){
    if(this.textoOriginal != this.datos.texto){
      this.botGuardar = true;
    } else{
      this.botGuardar = false;
    }
  }

  abreModalImgHtml(){
    const dialogRef = this.dialog.open(ModalImagenHtmlComponent, {
      width: '50%',
      disableClose: true,
      data: {
        carpetaBroker: this.datos.carpetaBroker
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  salir(opcion?:number) {
    this.datos.via = opcion;
    this.dialogRef.close(this.datos);
  }

}
